import type { NavigationConfig } from '@ingenico/react-section-utils';
import { listenCapabilities } from '@ingenico/react-section-utils';
import type { DeviceManagementSpiPort } from './domain/hexa/ports/spi.model';

export function deviceManagementDeveloperNavigation(spi: DeviceManagementSpiPort): NavigationConfig {
  return [
    {
      labelKey: 'navigation.page.apps',
      href: 'apps',
      onlyShowWhen: listenCapabilities(spi, [], ['apps.showInGlobalNavigation', 'apps.list']),
      icon: 'task',
      order: 20,
    },
  ];
}
